export default __webpack_public_path__ + "assets/loader.2b6052cc.gif";